import { ChatRequest } from '../../../core/models/api.models';
import { filterAuthorizedKnowledgeSources, KnowledgeSource } from '../../../core/models/knowledge-source';

export function createAuthorizedChatRequest(
  chatId: string,
  text: string,
  selected: readonly KnowledgeSource[],
  available: readonly KnowledgeSource[],
): ChatRequest | null {
  const knowledgeSources = filterAuthorizedKnowledgeSources(selected, available);
  return knowledgeSources.length ? { chatId, text, knowledgeSources } : null;
}
